document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".wholesale-table__wrapper");
    const loader = document.getElementById("loading-spinner");
    const correctPassword = wrapper.dataset.pass;
    const cookieName = "wholesale_access";

    // --- Helpers ---
    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    }

    // --- Main logic ---
    function showContent() {
      if (getCookie(cookieName) !== "true") {
        wrapper.innerHTML = `
          <div class="wholesale-login">
            <h3>This page is for wholesale customers only.
            If you would like to see our product information, please <a class="product-link" href="mailto:contact@jbqthelabel.com">contact</a> the store owner.</h3>
            <form id="wholesale-password-form" style="margin-top: 1em;">
              <input type="password" id="wholesale-password" placeholder="Enter password" required style="padding: 8px;margin-top: 10px;"/>
              <button type="submit">Submit</button>
            </form>
            <p id="wholesale-error" style="color:red; display:none; margin-top: 0.5em;">Incorrect password, please try again.</p>
          </div>
        `;

        wrapper.style.display = "block";

        const form = document.getElementById("wholesale-password-form");
        const errorMsg = document.getElementById("wholesale-error");

        form.addEventListener("submit", function (e) {
          e.preventDefault();
          const enteredPassword = document.getElementById("wholesale-password").value;
          if (enteredPassword === correctPassword) {
            setCookie(cookieName, "true", 60); // 60 days
            location.reload();
          } else {
            errorMsg.style.display = "block";
          }
        });
      }
      wrapper.style.display = "block";
      loader.style.display = "none";
    }

    setTimeout(() => {
      showContent();
    }, 1500);
  });